import { render, staticRenderFns } from "./BodyModal.vue?vue&type=template&id=7ba5a7c8&scoped=true&lang=pug&"
import script from "./BodyModal.vue?vue&type=script&lang=ts&"
export * from "./BodyModal.vue?vue&type=script&lang=ts&"
import style0 from "./BodyModal.vue?vue&type=style&index=0&id=7ba5a7c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba5a7c8",
  null
  
)

export default component.exports